<div>
	<div [style.minWidth.px]="minWidth" [ngClass]="typeClassMap[type]" class="mat-subheading-2 d-flex align-items-center text-white p-2 m-0">
		<mat-icon *ngIf="icon" class="mr-2 flex-shrink-0">{{ icon }}</mat-icon>
		<span>{{ description }}</span>
	</div>
</div>
